import { page } from '$app/stores';

import { get } from 'svelte/store';

import { InstitutionType } from '@do/models';

function resolveEntityLink({
  entityTypes,
  entityLink,
  fallbackLink,
}: {
  entityTypes: InstitutionType[];
  entityLink: string;
  fallbackLink: string;
}) {
  const { data } = get(page);
  const { configurations } = data;

  if (entityTypes.includes(configurations.type)) {
    return entityLink;
  }

  return fallbackLink;
}

export function resolveArtistLink(fallbackLink: string) {
  return resolveEntityLink({
    entityTypes: [InstitutionType.Artist, InstitutionType.Photographer],
    entityLink: '/biography/',
    fallbackLink,
  });
}

export function resolveCuratorLink(fallbackLink: string) {
  return resolveEntityLink({ entityTypes: [InstitutionType.Curator], entityLink: '/biography/', fallbackLink });
}
